module.exports = __webpack_public_path__ + "static/img/089.5a4a4a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/lkpy/089.png
// module id = BDLo
// module chunks = 0